import React from "react";
import styles from "./voiceMailAudioInner.module.scss";
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { noUrlData } from "../../../../base/callService/common";
type VoiceMailAudioInnerprops={
  voiceValues?: any;
  particularLog?: any;
}
export default function VoiceMailAudioInner({voiceValues, particularLog}:VoiceMailAudioInnerprops) {
  return (
    <>
      <AudioPlayer
        className="voicemailAudio"
        src={(voiceValues?.wavurl||particularLog?.recordingUrl)?(particularLog?.recordingUrl || voiceValues?.wavurl):''}
        autoPlay={false}
        customIcons={{
          play: <span className="icon_play" onClick={ ()=>noUrlData()}></span>,
          pause: <span className="icon_pausebar"></span>
        }}
        autoPlayAfterSrcChange={false}
        showFilledProgress={true}
        customProgressBarSection={
          [
            RHAP_UI.MAIN_CONTROLS,
            <div key={""} className={styles.audioSoundProgress}>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            ,
            RHAP_UI.DURATION
          ]
        }
        customControlsSection={
          [
            
          
            
          ]
        }
        timeFormat='mm:ss'
        
      />
    </>
  );
};
